var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-future-time",class:_vm.size},[(_vm.date)?_c('span',{staticClass:"icon mdi mdi-clock align-text-bottom"}):_vm._e(),(_vm.date)?_c('time',[_vm._v(_vm._s(_vm._f("moment")(_vm.date,_vm.format)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }